import React, { useEffect, useState } from 'react'
import { PageWrapper, Toggle } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import { uploadExcelFile } from '../../redux/actions/appActions'
import Error from '../../components/page-components/apps/upload-excel-file/error'
import Success from '../../components/page-components/apps/upload-excel-file/success'
import Loading from '../../components/page-components/apps/submit-potential-backcharge/loading'
import io from 'socket.io-client'
import { CONST_IO } from '../../constants/general'
import { REDUX_CONST } from '../../redux/constants'
import FinanceImport from '../../components/page-components/apps/upload-excel-file/finance'
import CommercialImport from '../../components/page-components/apps/upload-excel-file/commercial'
const DEPARTMENTS = { commercial: 'commercial', finance: 'finance' }
const UploadExcelFile = () => {
	const [department, setDepartment] = useState('')
	const dispatch = useDispatch()
	const { data, loading, error } = useSelector((state) => state.uploadExcelFile)

	const [sendChatMessage, setSendChatMessage] = useState(false)

	const uploadFileHandler = (file, sheetId) => {
		dispatch(
			uploadExcelFile({
				department,
				file,
				updateChatSpace: sendChatMessage,
				sheetId,
			}),
		)
	}

	useEffect(() => {
		// io('http://localhost:5000')
		// Connect to the Socket.IO server
		// Replace 'http://localhost:5000' with your server's URL
		//const socket = io('http://localhost:5000', { transports: ['websocket'] })
		const socket = io('https://www.nvoqe.com', { transports: ['websocket'] })
		// Setup event listeners

		socket.on(CONST_IO.events.WORKER_READY, (data) => {
			if (data.action === CONST_IO.actions.COMMERCIAL_EXCEL_FILE) {
				const { message, data: newData } = data.payload

				dispatch({
					type: REDUX_CONST.appConstants.uploadExcelFile.success,
					payload: {
						message,
						data: newData,
					},
				})
			}
		})

		// Clean up the effect
		return () => socket.disconnect()
	}, [])

	return (
		<PageWrapper showNavigation={true}>
			{/* <InitialForm showForm={showForm} onShowForm={showFormHandler} />*/}
			{loading && <Loading />}
			{data && <Success data={data.data} message={data.message} />}
			{error && <Error error={error} />}
			<div className=''>
				<div className='flex flex-col space-y-3'>
					<div className='max-w-96  mx-auto flex space-x-6 w-full justify-center items-center'>
						<button
							onClick={() => setDepartment(DEPARTMENTS.commercial)}
							className='w-full hover:scale-110 bg-romanRed2   dark:bg-romanGold1 dark:text-romanDark4 text-romanLight1 rounded-lg px-4 py-2 font-bold'
						>
							COMMERCIAL
						</button>
						<button
							onClick={() => setDepartment(DEPARTMENTS.finance)}
							className='w-full hover:scale-110 bg-romanRed2   dark:bg-romanGold1 dark:text-romanDark4 text-romanLight1 rounded-lg px-4 py-2 font-bold'
						>
							FINANCE
						</button>
					</div>
					<div
						className={`max-w-96  mx-auto flex items-center justify-center w-full pt-3 ${
							department === '' ? '' : 'font-bold text-xl'
						}`}
					>
						{department === DEPARTMENTS.commercial
							? 'COMMERCIAL UPLOADS'
							: department === DEPARTMENTS.finance
							? 'FINANCE UPLOADS'
							: 'Choose your department to upload a file'}
					</div>
					<div
						className={`max-w-96  mx-auto flex items-center justify-center w-full pt-3 `}
					>
						<Toggle
							wrapperClass={'flex items-center space-x-3'}
							label={'Send update message to google chat: '}
							labelClass={'text-sm'}
							toggleValue={sendChatMessage}
							onChange={() => setSendChatMessage((prev) => !prev)}
						/>
					</div>

					{department === DEPARTMENTS.commercial && (
						<CommercialImport onUploadFile={uploadFileHandler} />
					)}
					{department === DEPARTMENTS.finance && (
						<FinanceImport onUploadFile={uploadFileHandler} />
					)}
				</div>
			</div>
		</PageWrapper>
	)
}

export default UploadExcelFile
